var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1 7.3c0-.3-.1-.5-.3-.7L2 4.3V4h6l4.6 10.1 4-10.1h5.7v.3l-1.6 1.6c-.1.1-.2.3-.2.5V18c0 .2 0 .4.2.5l1.6 1.6v.3h-8.1V20l1.7-1.6c.2-.2.2-.2.2-.5V8.6l-4.6 11.8h-.6L5.4 8.6v7.9c0 .3.1.7.3.9L7.8 20v.3H1.7V20l2.2-2.6c.2-.2.3-.6.3-.9V7.3h-.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/Medium.de58b848aca3bb7ff617d539e5e54f8d.svg";
export { ForwardRef as ReactComponent };